import Style from 'ol/style/style'
import Stroke from 'ol/style/stroke'
import Fill from 'ol/style/fill'
import Circle from 'ol/style/circle'

/**
 * Estilos que usan las capas en la app
 */

export default new Style({
  image: new Circle({
    radius: 5,
    stroke: new Stroke({
      color: 'black',
      width: 2
    }),
    fill: new Fill({
      color: 'rgba(255, 235, 59, 0.5)'
    })
  }),

  stroke: new Stroke({
    color: 'rgb(255, 235, 59)',
    width: 3
  })
})

export const styleBuffer = new Style({
  image: new Circle({
    radius: 5,
    stroke: new Stroke({
      color: 'black',
      width: 2
    }),
    fill: new Fill({
      color: 'rgba(255, 235, 59, 0.5)'
    })
  }),

  stroke: new Stroke({
    color: 'rgb(0, 0, 0)',
    width: 3,
    lineDash: [0.5, 5]
  }),

  fill: new Fill({
    color: 'rgba(255, 235, 59, 0.2)'
  })
})


export const styleError = new Style({
  image: new Circle({
    radius: 5,
    stroke: new Stroke({
      color: 'black',
      width: 2
    }),
    fill: new Fill({
      color: 'rgba(211, 47, 47, 0.5)'
    })
  }),

  stroke: new Stroke({
    color: 'rgb(211, 47, 47)',
    width: 3,
    lineDash: [0.5, 5]
  }),

  fill: new Fill({
    color: 'rgba(211, 47, 47, 0.2)'
  })
})

export const nullStyle = new Style({
  image: new Circle({
    radius: 5,
    stroke: new Stroke({
      color: 'black',
      width: 2
    }),
    fill: new Fill({
      color: 'rgba(255, 235, 59, 0.5)'
    })
  }),
})

export const showStyle = new Style({
  image: new Circle({
    radius: 5,
    stroke: new Stroke({
      color: 'black',
      width: 2
    }),
    fill: new Fill({
      color: 'rgba(255, 235, 59, 0.5)'
    })
  }),

  stroke: new Stroke({
    color: 'rgb(255, 235, 59)',
    width: 4,
  }),
})

export const simpleStyle = new Style({
  image: new Circle({
    radius: 5,
    stroke: new Stroke({
      color: 'black',
      width: 2
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 0, 0.5)'
    })
  }),

  stroke: new Stroke({
    color: 'rgb(0, 0, 0)',
    width: 2,
  }),
})

export const styleDifference = new Style({
  fill: new Fill({
    color: 'rgba(0, 0, 0, 0.35)'
  })
})


// WEBPACK FOOTER //
// ./src/components/core/utils/style.js